var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.banner
    ? _c(
        "div",
        { staticClass: "banner border-radius-8" },
        [
          _c(
            "router-link",
            {
              staticClass: "item-wrap banner-item",
              attrs: { to: _vm.banner.href },
            },
            [
              _c("lazy-img", {
                attrs: {
                  width: "100%",
                  height: "100%",
                  background: "transparent",
                  src: _vm.banner.imgUrl,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }